import { amountToDisplayValue, Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { EMPTY_VALUE_PLACEHOLDER } from '../../../../constants/emptyValuePlaceholder'

interface SupplierBalanceAmountProps {
  value?: number
  renderDash?: boolean
  bold?: boolean
}

export const SupplierBalanceAmount = ({
  value,
  renderDash = false,
  bold = false,
}: SupplierBalanceAmountProps): ReactElement => (
  <Text
    as="span"
    inherit
    weight={bold ? 'bold' : undefined}
    color={!renderDash && value !== undefined && value < 0 ? Color.Red700 : undefined}
  >
    {renderDash ? EMPTY_VALUE_PLACEHOLDER : amountToDisplayValue(value ?? 0)}
  </Text>
)
